import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Program } from 'src/app/store/programs.era';
import { ManageProgramData, ProgramTabs, programTabs } from 'globals/store/programs.data';
import { LabelObject } from 'globals/store/events.data';
import { ManageWrapperComponent, Tab, TabGroup } from './manage-wrapper.component';
import { TagPanelData, TagType } from 'globals/store/tags.data';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { JoiEvent } from 'src/app/store/events.era';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { CommonModule } from '@angular/common';
import { TimezoneSelectorComponent } from 'src/app/components/timezone-selector/timezone-selector.component';
import { exhibitorDisplayTypes } from 'globals/store/exhibitors.data';
import { ProgramBasicsComponent } from '../logistics/program-basics.component';
import { DeleteButtonComponent } from 'src/app/components/buttons/delete-button.component';
import { ProgramSetupComponent } from './manage-program-setup.component';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { AssetsComponent } from '../assets/assets.component';
import { ExhibitorStandsComponent } from '../exhibitors/exhibitor-stands.component';
import { removeUniqueStringFromList } from 'src/app/helpers/helpers';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { programPermissionsReselector, programTagReselector } from 'src/app/store/reselectors/programs.reselector';
import { JoiFile } from 'globals/store/files.model';
import { ProgramTagPanelComponent } from '../logistics/program-tag-panel.component';
import { jsonCopyObject } from 'globals/helpers/helpers';


@Component({
    selector: 'manage-program',
    templateUrl: './manage-program.html',
    styleUrls: ['manage-dialogs.scss'],
    styles: [`
  :host ::ng-deep expanding-wrapper .wrapper-title { padding: 10px; }
`],
    standalone: true,
    imports: [CommonModule, ManageWrapperComponent, ProgramTagPanelComponent, ProgramBasicsComponent, ExhibitorStandsComponent,  IdsToItemsPipe, ProgramSetupComponent, ExpandingWrapperComponent, DeleteButtonComponent, AssetsComponent

    ]
})
export class ManageProgramComponent extends Wrapper<ManageProgramComponent> implements OnInit {

  _file = 'manage-program'
  labels;
  program: Program;

  dateChanged = false
  is_program = false
  is_logistics = false
  is_readonly = true
  exhibitorDisplayTypes = exhibitorDisplayTypes

  programTabs = programTabs
  searchCost = 0
  labelMap: LabelObject
  latLngPattern = new RegExp(/^-?\d*\.?\d*$/);
  @ViewChild('latitudeInput') latitude: JoiInputComponent
  @ViewChild('longitudeInput') longitude: JoiInputComponent

  tabGroups: TabGroup<keyof ProgramTabs>[] = [{ groupName: 'LOGISTICS', tabs: [
    { id: programTabs.basics, name: 'Date & venue' },
    { id: programTabs.assets, name: 'Room/Location Assets' },
    { id: programTabs.setup, name: 'Setup' },
    { id: programTabs.exhibitorStands, name: 'Exhibitor Stands' },
    { id: programTabs.tagging, name: 'Tagging' },
  ]}]
  selectedTab: Tab<keyof ProgramTabs>
  tagData: TagPanelData
  cachedLatLong: { latitude: number, longitude: number }
  // googleMapsLink: SafeResourceUrl
  // previousGoogleMapsUnsanitizedLink: string = null
  showAddDisplayTimeZone = false;
  event: JoiEvent
  openSetups: Dictionary<boolean> = {}

  @ViewChild(TimezoneSelectorComponent) timezoneSelector: TimezoneSelectorComponent
  

  public labelUpdateFunction({ labelTemplate, labelsChanged, labelsToggled, labels }: LabelUpdateFunctionParams) {
    // Updates to labels on an event don't go through the label dialog template but rather the entire event changes dialog (and are only saved on "save changes" or what have you)  The label template can still change, though
    if (labelsToggled) {
      this.program.labels = labels
      this.saveProgram()
    }
    if (labelsChanged) {
      this.eventService.updateEvent(this.eventService.eventId, { program_labels: labelTemplate })
    }
  }

  constructor(public dialogRef: MatDialogRef<ManageProgramComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageProgramData) {
    super()
    if (data.openTab) this.selectedTab = this.tabGroups[0].tabs.find(t => t.id === data.openTab)
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subCallback(this.store.select('programs', 'entities'), programs => {
      const program: Program = programs[data.programId]
      if (!program) {
        return console.log(`Missing program!  Program id: ${data.programId}`, { programs })
      }
      if (!this.program) {
        // not initialized yet
        if (program.setupIds.length === 1) this.openSetups[program.setupIds[0]] = true
      }
      this.program = jsonCopyObject(program)
    })
    this.subCallback(this.store.select('events', 'labelMaps', 'program_labels'), labelMap => {
      this.labels = Object.values(labelMap)
      this.labelMap = labelMap
    })
    this.selectCallback<{is_readonly: boolean, is_program: boolean, is_logistics: boolean}, null>(programPermissionsReselector, null, ({ is_readonly, is_program, is_logistics }) => {
      this.is_readonly = is_readonly
      this.is_program = is_program
      this.is_logistics = is_logistics
    })
  }

  ngOnInit() {
    this.subProp(this.store.select(programTagReselector, this.data.programId), 'tagData')
  }

  updateProgramTitle(newTitle: string) {
    this.program.title = newTitle
    this.eventService.setProgramName(this.program.id, newTitle)
    this.saveProgram()
  }

  changeTab(tab) {
    this.selectedTab = tab
  }

  async deleteSetup(setupId: string) {
    this.program.setupIds = this.program.setupIds.filter(id => id !== setupId)
    delete this.program.setups[setupId]
    const partialProgram = { setups: this.program.setups, setupIds: this.program.setupIds }
    await this.programService.sendProgramUpdate(this.program.id, partialProgram, { file:this._file, function:'deleteSetup', data: partialProgram })
  }

  exit() {
    this.dialogRef.close(this.data.fromOss ? this.dateChanged : null)
  }


  setTags({ tagType, ids }: { tagType: TagType, ids: string[] }) {
    switch (tagType) {
      case 'workforce': 
        this.program.workforceTags = ids
        break
      case 'performer':
        this.program.performerTags = ids
        break
      case 'sponsor':
        this.program.sponsorTags = ids
        break
      case 'exhibitor':
        this.program.exhibitorTags = ids
        break
      case 'resource':
        this.program.resourceTags = ids
        break
      case 'attendee':
        this.program.attendeeTags = ids
        break
      default:
        console.log(`Missing case for type: ${tagType}`)
        return
    }
    this.saveProgram()
  }

  removeTag({ tagType, id }: { tagType: TagType, id: string }) {
    switch (tagType) {
      case 'attendee': 
        removeUniqueStringFromList(this.program.attendeeTags, id)
        break
      case 'workforce': 
        removeUniqueStringFromList(this.program.workforceTags, id)
        break
      case 'performer':
        removeUniqueStringFromList(this.program.performerTags, id)
        break  
      case 'sponsor':
        removeUniqueStringFromList(this.program.sponsorTags, id)
        break  
      case 'exhibitor':
        removeUniqueStringFromList(this.program.exhibitorTags, id)
        break      
      case 'resource':
        removeUniqueStringFromList(this.program.resourceTags, id)
        break
      default:
        console.log(`Missing case for type: ${tagType}`)
        return
    }
    this.saveProgram()
  }
  
  toggleProgramConfirmed() {
    this.program.programConfirmed = !this.program.programConfirmed
    this.saveProgram()
  }

  async duplicate() {
    // console.log("DUPLICATING?")
    await this.programService.duplicateProgram(this.program)
    this.dialogRef.close()
  }
  
  saveFiles(files: JoiFile[]) {
    this.program.files = files
    this.saveProgram()
  }

  saveAssetIds(ids: string[]) {
    const oldIds = this.program.assetIds || []
    this.program.assetIds = [...oldIds, ...ids]
    this.saveProgram()
  }

  removeAssetId(idToRemove: string) {
    this.program.assetIds = this.program.assetIds.filter(id => id !== idToRemove)
    this.saveProgram()
  }

  async delete() {
    // console.log("DELETING?")
    await this.programService.deleteProgram(this.data.programId)
    this.dialogRef.close()
  }

  async saveProgram() {
    await this.programService.upsertProgram(this.program, {file:this._file, function:'saveProgram', data:{program: this.program}}, false)
  }

  async addSetup() {
    console.log({program: this.program})
    const id = await this.programService.addSetup(this.program)
    this.openSetups[id] = true
  }

}